import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import HomePage from '../components/Home';
import { getFeaturedMatches } from '../actions/feature';


type AppDispatch = ThunkDispatch<RootReducerState, unknown, FeatureAction>;

interface MapStateToProps {
  content: RootStockData | undefined;
}

const mapStateToProps = (state: RootReducerState): MapStateToProps => {
  return {
    content: state.featured.content
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getFeaturedMatches: (date?: string) => dispatch(getFeaturedMatches(date))
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type HomeProps = ConnectedProps<typeof connector>;
export default connector(HomePage);
